import React, {useEffect, useRef, useState} from 'react';
import './DropdownSelect.css';
import DropDownIcon from "../../assets/DropDownIcon";

const DropdownSelect = ({
                            options = [],
                            selectedValue,
                            onChange,
                            renderIndicator,
                            renderLabel,
                            background = 'rgb(241, 241, 241)',
                            children,
                            styles = {},
                            classes = ''
                        }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };


    useEffect(() => {
        if (isOpen) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div style={styles} className={'dropdown-select-parent-div ' + classes} ref={dropdownRef}>
            <div
                style={{background: background}}
                className={`dropdown ${isOpen ? 'show' : ''}`}
                onClick={toggleDropdown}
            >
                {renderIndicator && renderIndicator(selectedValue)}
                <span style={{marginLeft: '5px'}}>{renderLabel && renderLabel(selectedValue)}</span>
                <div style={{marginRight: '5px'}}>
                    <DropDownIcon width="8" height="4"/>
                </div>
            </div>
            <div key={'dropdown-menu'} className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
                {   children?
                    options.map((option, index) => (
                        <div
                            key={option.value || option.name || index}
                            className="dropdown-item"
                            onClick={() => {
                                onChange(option.value ? option.value : option);
                                setIsOpen(false);
                            }}
                        >
                            {children(option)}
                        </div>
                    ))
                    :
                    options.map((option, index) => (
                        <div
                            key={option.value || option.name || index}
                            className="dropdown-item"
                            onClick={() => {
                                onChange(option.value ? option.value : option);
                                setIsOpen(false);
                            }}
                        >
                            {option.label ? option.label : option.name}
                        </div>
                    ))
                }

            </div>
        </div>
    );
};

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components-new/DropdownSelect/index.jsx